import { actionTypes } from '@/types';

import sendErrorMessage from './sendErrorMessage';
import pushUrl from './pushUrl';
import openUrl from './openUrl';
import loadContent from './loadContent';
import fetchArticleContent from './fetchArticleContent';
import loadDataSource from './loadDataSource';
import setExhibition from './setExhibition';
import setStyleUrl from './setStyleUrl';
import setStyleTemplate from './setStyleTemplate';
import { analyticsInitialize, analyticsLog } from './analytics';
import loadGlossary from './loadGlossary';
import loadCalendar from './loadCalendar';
import { startSubModule, stopSubModule } from './subModule';
import setArticle from './setArticle';
import setArticleByCode from './setArticleByCode';
import setFontSize from './setFontSize';
import setColorMode from './setColorMode';
import { openModal, toggleModal, closeModal, openContentInIframe } from './modal';
import setLanguage from './setLanguage';
import loanerStart from './loanerStart';
import addToMediaObjectMap from './addToMediaObjectMap';
import registerStoreModule from './registerStoreModule';
import openCardView from './openCardView';

export default {
	[actionTypes.sendErrorMessage]: sendErrorMessage,
	[actionTypes.pushUrl]: pushUrl,
	[actionTypes.loadContent]: loadContent,
	[actionTypes.fetchArticleContent]: fetchArticleContent,
	[actionTypes.setStyleTemplate]: setStyleTemplate,
	[actionTypes.setStyleUrl]: setStyleUrl,
	[actionTypes.analyticsInitialize]: analyticsInitialize,
	[actionTypes.analyticsLog]: analyticsLog,
	// async [actionTypes.updateStyleContent]({ state, commit }) {
	// 	const result = await Vue.http.get(state.styleTemplateURL + `#${Date.now()}`);
	// 	commit(mutationTypes.activeCssMode, {
	// 		content: result.body,
	// 	});
	// },
	[actionTypes.loadDataSource]: loadDataSource,
	[actionTypes.loadGlossary]: loadGlossary,
	[actionTypes.loadCalendar]: loadCalendar,
	[actionTypes.startSubModule]: startSubModule,
	[actionTypes.stopSubModule]: stopSubModule,
	[actionTypes.setFontSize]: setFontSize,
	[actionTypes.setColorMode]: setColorMode,
	[actionTypes.openModal]: openModal,
	[actionTypes.toggleModal]: toggleModal,
	[actionTypes.closeModal]: closeModal,
	[actionTypes.setLanguage]: setLanguage,
	[actionTypes.setArticleByCode]: setArticleByCode,
	[actionTypes.setArticle]: setArticle,
	[actionTypes.setExhibition]: setExhibition,
	[actionTypes.loanerStart]: loanerStart,
	[actionTypes.openUrl]: openUrl,
	[actionTypes.addToMediaObjectMap]: addToMediaObjectMap,
	[actionTypes.registerStoreModule]: registerStoreModule,
	[actionTypes.openContentInIframe]: openContentInIframe,
	[actionTypes.openCardView]: openCardView,
};
